var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/user-octagon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-octagon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.3502 10.725V19.275C26.3502 20.675 25.6002 21.9751 24.3877 22.6876L16.9627 26.975C15.7502 27.675 14.2502 27.675 13.0252 26.975L5.6002 22.6876C4.3877 21.9876 3.6377 20.6875 3.6377 19.275V10.725C3.6377 9.32504 4.3877 8.02499 5.6002 7.31249L13.0252 3.025C14.2377 2.325 15.7377 2.325 16.9627 3.025L24.3877 7.31249C25.6002 8.02499 26.3502 9.31254 26.3502 10.725Z",
    fill: "#1C5158"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.0004 13.7498C16.6089 13.7498 17.9129 12.4458 17.9129 10.8372C17.9129 9.22872 16.6089 7.9248 15.0004 7.9248C13.3919 7.9248 12.0879 9.22872 12.0879 10.8372C12.0879 12.4458 13.3919 13.7498 15.0004 13.7498Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20 20.8249C20 18.5749 17.7625 16.75 15 16.75C12.2375 16.75 10 18.5749 10 20.8249",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2c6a9ac58d60feaefd56e0bd36722b93.svg";
export { ForwardRef as ReactComponent };